<template>
  <v-container fluid >
    <v-row style="background-color: #3A3A3A" align="center" class="pa-16">
      <v-col align="center">
        <h1 class="px-10 white--text pt-0">Meet Our Team</h1>
      </v-col>
    </v-row>

    <v-row class="pt-16">
      <v-col align="center">
        <h4  :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : 'px-2'">
          Every 3545 partner is an official member of the Microsoft Partner
          Network and Value-Added Resellers for many software
          solutions. Additionally, our experienced team of consultants and
          associates hold individual and corporate certifications in a variety
          of computer and data technologies and software applications.
        </h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xl="3" lg="3" md="3" sm="4" xs="12"> 
         <Filters /> 
      </v-col>
      <v-col cols="12" xl="9" lg="9" md="9" sm="8" xs="12">
        <Members />
      </v-col>
    </v-row>
  </v-container>
</template>


<style scoped>
h1 {
  font-size: 48px;
}
</style>




<script>
import Members from "@/components/team/Members.vue";
import Filters from "@/components/team/Filters.vue";

import DataMixin from "@/components/global/mixins/DataMixin";

export default {
  mixins: [DataMixin],
  components: {
    Members,
    Filters,
  },
};
</script>
 
